import React, { lazy, Suspense } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/index.css';
import Navigation from './components/Navigation';
import { useNavigationState } from './hooks/useNavigationState';

// Lazy load page components for better performance
const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Team = lazy(() => import('./pages/Team'));
const Contact = lazy(() => import('./pages/Contact'));

function App() {
  const { scrolled, mobileMenuOpen, toggleMobileMenu, closeMobileMenu } = useNavigationState();

  return (
    <Router>
      <div className="App">
        {/* Skip to main content link for screen readers */}
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>

        <Navigation
          scrolled={scrolled}
          mobileMenuOpen={mobileMenuOpen}
          toggleMobileMenu={toggleMobileMenu}
          closeMobileMenu={closeMobileMenu}
        />

        <main id="main-content" className="main-content">
          <Suspense fallback={<div className="loading-container">Loading...</div>}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/team" element={<Team />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </Suspense>
        </main>

        <footer className="footer">
          <p>&copy; 2026 ONESTOPCORP DBA ONE STOP CAPITAL. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;